module.exports = __webpack_public_path__ + "img/jump1.0.1.36403f9f.gif";